import React, { useEffect, useState } from "react";
// Styles
import Styles from "./styles";
// Tools
import { useParams, useNavigate } from "react-router-dom";
// GraphQL
import { useMutation, useQuery } from "@apollo/client";
import { PROCESS_INFERENCE, RETRIEVE_INFERENCE } from "../../graphql/user";
// Components
import SpinnerComponent from "../../components/Loader";
import PrimaryBtn from "components/Shared/Buttons/PrimaryBtn/PrimaryBtn";

const InferenceResult = () => {
  const [retrievedInference, setRetrievedInference] = useState(null);
  const { inferenceCode } = useParams();
  const navigate = useNavigate();

  const [
    processInferenceMutation,
    {
      data: processInferenceData,
      loading: processInferenceLoading,
      error: processInferenceError, //TODO Handle graphql error
    },
  ] = useMutation(PROCESS_INFERENCE, {
    context: { clientName: "user" },
  });

  const {
    data: retrievedInferenceData,
    loading: retrieveInferenceLoading,
    error: retrieveInferenceError,
  } = useQuery(RETRIEVE_INFERENCE, {
    variables: { inferenceCode: processInferenceData?.processInference?.result?.inferenceCode },
    skip: !processInferenceData,
    context: { clientName: "user" },
  });

  useEffect(() => {
    processInferenceMutation({ variables: { inferenceCode: inferenceCode } });
  }, [inferenceCode, processInferenceMutation]);

  useEffect(() => {
    if (retrievedInferenceData) {
      setRetrievedInference(retrievedInferenceData.retrieveInference.data);
    }
  }, [retrievedInferenceData]);

  const handleClickBackBtn = () => {
    navigate("/");
  };

  return (
    <Styles.SectionContainer>
      <Styles.AlignmentContainer>
        {processInferenceLoading || retrieveInferenceLoading ? (
          <Styles.HeaderContainer>
            <h1>Processing Data</h1>
            <SpinnerComponent width={100} height={100} />
          </Styles.HeaderContainer>
        ) : (
          <Styles.ErrorAndBackContainer>
            {processInferenceError || retrieveInferenceError ? (
              <Styles.ErrorMessage>
                Sorry, something went wrong. Please try another model.
              </Styles.ErrorMessage>
            ) : null}
            <PrimaryBtn handleClick={handleClickBackBtn} label="Back to Models" />
          </Styles.ErrorAndBackContainer>
        )}
      </Styles.AlignmentContainer>
    </Styles.SectionContainer>
  );
};

export default InferenceResult;
